import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { getLatestArticles } from "@/mocks/articles";
import { formatHeat } from "@/utils/format";

export default function TimelineSection() {
  const timeline = [...getLatestArticles(5)].sort((a, b) => (a.publishedAt < b.publishedAt ? -1 : 1));

  return (
    <section className="border-y border-background-200 bg-background-100">
      <div className="mx-auto max-w-[1400px] px-4 py-16 md:px-6 md:py-20">
        <SectionHeading
          eyebrow="TIMELINE"
          title="瓜田时间线"
          description="把最近发生的大瓜按时间串成一条线，从上到下就是事件发酵的完整顺序。"
        />

        <ol className="relative space-y-6 border-l border-background-300 pl-6 lg:grid lg:grid-cols-5 lg:gap-5 lg:space-y-0 lg:border-l-0 lg:border-t lg:pl-0 lg:pt-8">
          {timeline.map((article) => (
            <li key={article.id} className="relative lg:pt-6">
              <span className="absolute -left-[31px] top-1.5 flex h-3 w-3 items-center justify-center rounded-full border-2 border-background-100 bg-primary-500 lg:-top-[21px] lg:left-1/2 lg:-translate-x-1/2" />
              <span className="absolute -left-[31px] top-1.5 h-3 w-3 animate-ping rounded-full bg-primary-500/40 lg:-top-[21px] lg:left-1/2 lg:-translate-x-1/2" />
              <span className="mb-2 block text-xs font-medium tracking-wider text-foreground-500 lg:text-center">
                {article.publishedAt}
              </span>
              <Link
                to={`/article/${article.id}`}
                className="group block rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300 cursor-pointer"
              >
                <span className="mb-2 inline-flex items-center gap-1 text-[11px] text-accent-700">
                  <i className="ri-fire-fill" />
                  {formatHeat(article.heat)} 热度
                </span>
                <h3 className="line-clamp-3 text-sm font-semibold text-foreground-900 transition-colors group-hover:text-primary-600">
                  {article.title}
                </h3>
              </Link>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}